import { RootState } from "@/redux/store";

export const seenCampaignsSelector = (state: RootState) => state.announcementTour.seenCampaigns;

/**
 * Whether this campaign has already been dismissed.
 *
 * A factory rather than a plain selector so callers name the campaign at the call site, and so a
 * component can never accidentally read another campaign's state.
 */
export const hasSeenCampaignSelector = (campaignId: string) => (state: RootState) =>
  state.announcementTour.seenCampaigns.includes(campaignId);
